var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTizy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40.674,
    height: 17.16,
    viewBox: "0 0 40.674 17.16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_362",
    "data-name": "Groupe 362",
    transform: "translate(0 -0.001)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1441",
    "data-name": "Trac\\xE9 1441",
    d: "M115.576,49.283l-.614,11.986,4.652-.072.735-9.866-.36-.974V49Z",
    transform: "translate(-103.495 -44.109)",
    fill: "#f37e72"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1442",
    "data-name": "Trac\\xE9 1442",
    d: "M185.978,24.019,175.65,23.75l.257,3.341-.343.557.771,1.242,3-.386-4.349,4.84.665,2.955V38.19l9.551-.563.9-2.655-.728-1.542-3.721.257,4.449-5.4Z",
    transform: "translate(-157.531 -21.38)",
    fill: "#f37e72"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1443",
    "data-name": "Trac\\xE9 1443",
    d: "M297.828,30.642l.734.682,2.778,3.119V38.19h4l.94-1.009-.4-3.079,2.534-3.132.39-6.906-4.629-.195.487,6.189-.926,1.451-1.218-2.328.258-5.038-4.94-.393Z",
    transform: "translate(-268.121 -21.38)",
    fill: "#f37e72"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1444",
    "data-name": "Trac\\xE9 1444",
    d: "M9.58,19.34,0,19.269l.321,2.989L0,23.313l1.142,1.055,2.08-.586.615,9.288,4.424,1.083-.615-9.873,2.813.176.795-4.893-1.176-.607Z",
    transform: "translate(0 -17.064)",
    fill: "#f37e72"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1445",
    "data-name": "Trac\\xE9 1445",
    d: "M125.873,0l-.295.167-.071.222-.216.193L124.9.139,123.7.122l-1.625,1.7.859,1.919,2.785.128.746-1.935-.329-.377.1-.057.293-.057.338-.267Z",
    transform: "translate(-109.903)",
    fill: "#f37e72"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTizy);
export default __webpack_public_path__ + "static/media/tizy.5b8918ea63884494106a9da05ee59ea4.svg";
export { ForwardRef as ReactComponent };